// UUID of Pepper Employee model
export const PEPPER_SUPPORT_UUID = '00000000-0000-0000-0000-000000000000';
export const DEBOUNCE_REQUEST_TIME_MS = 2500;
export const ANIMATED_OPACITY_DURATION_MS = 250;
